module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plm_hd"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_serpref"
    }
  }, [_vm._v("Series preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_autpref"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_abbrev"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch01"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("1 Introduction and statement of the problem")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch01#sigil_toc_id_2"
    }
  }, [_vm._v("The problems of the book of Job")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch01#sigil_toc_id_3"
    }
  }, [_vm._v("A word on myth")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch02"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("2 Job’s tragedy (chs. 1–2) and the failure of the debate with his friends (chs. 3–37)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch02#sigil_toc_id_5"
    }
  }, [_vm._v("Job’s integrity, the Accuser’s question and Job’s costly worship (Job 1 – 2)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch02#sigil_toc_id_6"
    }
  }, [_vm._v("The debate between Job and his friends: round one (chs. 4–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch02#sigil_toc_id_7"
    }
  }, [_vm._v("Reflections on the first round of the debate (chs. 4–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch02#sigil_toc_id_8"
    }
  }, [_vm._v("Round two of the debate (chs. 15–21)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch02#sigil_toc_id_9"
    }
  }, [_vm._v("Round three of the debate (chs. 22–27)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch02#sigil_toc_id_10"
    }
  }, [_vm._v("Wisdom’s inaccessibility (ch. 28) and Job’s final assertion of innocence (chs. 29–31)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch02#sigil_toc_id_11"
    }
  }, [_vm._v("Elihu (chs. 32–37)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PL_ch02#sigil_toc_id_12"
    }
  }, [_vm._v("Evaluating the debate between Job and his friends")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("3 Y")]), _c('span', {
    staticClass: "smallcaps_bold2"
  }, [_vm._v("hwh")]), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("’s first speech and his rule over creation (Job 38:1 – 40:5)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03#sigil_toc_id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Then the L"), _c('span', {
    staticClass: "smallcaps_rom2"
  }, [_vm._v("ord")]), _vm._v(" answered . . . and said’ (38:1): "), _c('span', {
    staticClass: "smallcaps_rom2"
  }, [_vm._v("yhwh")]), _vm._v("’s introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03#sigil_toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Y"), _c('span', {
    staticClass: "smallcaps_rom2"
  }, [_vm._v("hwh")]), _vm._v("’s opening challenge to Job (38:2–3)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03#sigil_toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who was it that founded the earth? (38:4–7)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03#sigil_toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical questions and the issue of tone")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03#sigil_toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘swaddling’ of the raging sea (38:8–11)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03#sigil_toc_id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The moral significance of the sunrise (38:12–15)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03#sigil_toc_id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s tour through different parts of the cosmos (38:16–38) and the animals inhabiting it (38:39 – 39:30)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03#sigil_toc_id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Human limits, divine goodness and the continuing presence of evil: the significance of "), _c('span', {
    staticClass: "smallcaps_rom2"
  }, [_vm._v("yhwh")]), _vm._v("’s first speech to Job")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03#sigil_toc_id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A significant rival interpretation of "), _c('span', {
    staticClass: "smallcaps_rom2"
  }, [_vm._v("yhwh")]), _vm._v("’s first speech")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch03#sigil_toc_id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Job’s response (40:1–5): Is he satisfied? Is the reader?")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("4 Y")]), _c('span', {
    staticClass: "smallcaps_bold2"
  }, [_vm._v("hwh")]), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("’s second speech and the defeat of Leviathan (Job 40:6 – 41:34)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch04#sigil_toc_id_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Will you break my justice?’2 (40:6–8)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch04#sigil_toc_id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The preparation of the divine warrior (40:9–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch04#sigil_toc_id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Behemoth: the ‘Superbeast’ (40:15–24)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch04#sigil_toc_id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leviathan: the twisting, fleeing serpent (41:1–34)26")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch04#sigil_toc_id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Possible interpretations of Behemoth and Leviathan")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch04#sigil_toc_id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evidence for Behemoth and Leviathan as symbols of supernatural chaos and evil")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch04#sigil_toc_id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The hopeful and comforting implications of "), _c('span', {
    staticClass: "smallcaps_rom2"
  }, [_vm._v("yhwh")]), _vm._v("’s second speech")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch04#sigil_toc_id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The limitations of God’s second speech to Job")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("5 Job’s restoration and the question of theodicy (ch. 42)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch05#sigil_toc_id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Now my eye sees you’: Job’s second response (42:1–6)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch05#sigil_toc_id_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Job’s restoration (42:7–17)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch05#sigil_toc_id_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The book of Job and the question of theodicy")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch05#sigil_toc_id_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The unique contribution of the book of Job to suffering and the problem of evil")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("6 Summary and conclusion")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_bibliog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ind_aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search items for authors")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ind_scr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search terms for Scripture references")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_sertit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Titles in this series:")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PL_IVPtbs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Academic Textbook Selector")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f7c8dad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/PL_contents.vue
// module id = 66
// module chunks = 0